import Image from 'app/Components/Shared/Image/image';
import React ,{useEffect} from 'react';
import { ProcessTypeTitles, ProcssType } from './constant';
import BtnSubmit from '../Buttons/BtnSubmit';

const BlockingDualNumberPage = ({subscriberNo, processType, onSubmit}) => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const processTypeTitle = ProcessTypeTitles[processType];
    return (
        <div className='blocking-dual-number-page'>
            <div>
                <Image src={require('./error-icon.svg')} alt="error" />
                    <div className="title">
                        המנוי  {subscriberNo} <br/>
                         הינו
                        קו נוסף ב- Esim
                    </div>
                    <div className="sub-title">
                    {processTypeTitle}
                 </div>
            </div>
            <BtnSubmit text="סיום" onclick={onSubmit} />
        </div>
    );
};

export default BlockingDualNumberPage;
